import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';

import { ArrowLeft, ArrowRight, Check, X } from 'react-bootstrap-icons';

import ChooseRaces from './search/ChooseRaces';

import {
  formatMoney,
  formatRace
} from '../common';

import {loadStripe} from '@stripe/stripe-js';
import {useStripe, useElements, CardElement, Elements, PaymentElement} from '@stripe/react-stripe-js';

const stripePromise = document.getElementById('stripe_key') ? loadStripe(document.getElementById('stripe_key').value) : null;

const CheckoutForm = () => {

  const [chooseRaces, setChooseRaces] = useState(false);
  const [email, setEmail] = useState(oldEmail ? oldEmail : '');
  const [name, setName] = useState(oldName ? oldName : '');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState('');
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [races, setRaces] = useState([]);
  const [preRaces, setPreRaces] = useState([]);
  const [all, setAll] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const stripe = useStripe();
  const elements = useElements();

  const setupIntent = document.getElementById('setup_intent').value;

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setError('');
    setSubmitting(true);


    const result = await stripe.confirmCardSetup(setupIntent, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          name
        }
      },
    });

    console.log('result', result);

    if (result.error)
    {
      setError(result.error.message);
      setSubmitting(false);
    }
    else
    {
      //console.log('success', result);

      axios.post('/api/subscribe', {
        payment_method: result ? result.setupIntent.payment_method : null,
        all,
        races,
        name,
        email,
        password,
        password_confirmation: passwordConfirmation
      }).then(response => {
        //console.log('response', response)
        setSuccess(true);
        setSubmitting(false);
      }).catch(error => {
        if (error.response && error.response.data)
        {
          if (error.response.data.errors)
          {
            setErrors(error.response.data.errors);
            if (error.response.data.message !== 'The given data was invalid.')
            {
              setError(error.response.data.message);
            }
          }
        }
        setSubmitting(false);
      });
    }
  };

  const toggleMultiple = (value, array) => {
    if (array.includes(value))
    {
      return array.filter(item => item !== value);
    }

    return [...array, ...[value]];
  };

  const calculateTotal = () => {
    if (all)
    {
      return formatMoney(2500);
    }
    return formatMoney(races.length * 100);
  }

  const handleClose = () => {
    setChooseRaces(false);
  }

  return (
    <>

      {all || races.length > 0 ? null : (
        <div id='choose-plan-bg'></div>
      )}

      <div className="container mb-3">
        <div className="row justify-content-center">
            <div className="col-md-12">

                  {all || races.length > 0 ? null : (
                    <>
                      <div className="text-center mt-3">
                        <img src="/assets/primary-logo_choose-plan.svg" style={{width: 200}} />
                      </div>
                      <h1 className="text-center my-4" style={{color: '#fff'}}>
                       {loggedIn ? (
                         <>Your subscription has ended!<br />Subscribe, and you will never miss a dime!</>
                       ) : (
                         <>Welcome to 527tracker!</>
                       )}
                      </h1>

                      <p className="text-center text-dark mx-4">
                        We have two powerful plans to showcase your needs. Buy all the data and unlimited spending alerts with Pro, or just what you need in subscribing by race.
                      </p>
                    </>
                  )}

                  <Row>
                    <Col>
                      <Row className="choose-plan justify-content-md-center">
                        {(all || races.length > 0) && ! trialForm ? (
                          <div className="py-2 mb-2 border-bottom">
                            <a
                              href="#"
                              onClick={e => {
                                e.preventDefault();
                                setRaces([]);
                                setAll(false);
                              }}
                              className="text-decoration-none"
                            >
                              <ArrowLeft className="success" /> Switch Plan
                            </a>
                          </div>
                        ) : (
                          <div className="py-2 mb-2 border-bottom">
                            <a
                              href="/"
                              className="text-decoration-none"
                            >
                              <ArrowLeft className="success" /> Back
                            </a>
                          </div>
                        )}
                        {! all ? (
                          <Col md={races.length === 0 ? 4 : 8}>

                            <Card className="text-center per-race-plan mt-2">
                              <Card.Body>
                                <Card.Title>Subscribe by Race</Card.Title>
                                <Card.Text>
                                  <ListGroup className="text-left" variant="flush">
                                    <ListGroup.Item>
                                      <Check className="plan-options" /> Free 1 month trial for new user.
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Check className="plan-options" /> Only pay for the races you need for $100/race per month.
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Check className="plan-options" /> Receive real-time spending notifications on selected races.
                                    </ListGroup.Item>
                                    <ListGroup.Item className="not-available">
                                      <X className="plan-options" /> Unlimited Access to Data
                                    </ListGroup.Item>
                                    <ListGroup.Item className="not-available">
                                      <X className="plan-options" /> Dashboard on selected exclusive deals races.
                                    </ListGroup.Item>
                                  </ListGroup>
                                  <p className="text-left"><span className="price">$100</span>/race per month</p>
                                </Card.Text>
                                <Button
                                  id="choose-per-race"
                                  onClick={() => setChooseRaces(true)}
                                >
                                  {races.length === 0 ? (
                                    (trialForm ? 'FREE 30-Day trial' : 'Choose Per Race')
                                  ) : (
                                    'Update Selected Races'
                                  )}
                                </Button>
                              </Card.Body>
                            </Card>

                          </Col>
                        ) : null}
                        {races.length === 0 ? (
                          <Col md={! all ? 4 : 8}>

                            <Card className="text-center pro-plan mt-2">
                              <Card.Body>
                                <Card.Title>All Access Pro</Card.Title>
                                <Card.Text>
                                  <ListGroup className="text-left" variant="flush">
                                    <ListGroup.Item>
                                      <Check className="plan-options" /> Free 1 month trial for new user.
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Check className="plan-options" /> All access pass to dashboard and realtime spending alerts in every race.
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                      <Check className="plan-options" /> Ability to cross reference spending across all races, committees, vendors, candidates, and even cycles.
                                    </ListGroup.Item>
                                  </ListGroup>
                                  <p className="text-left"><span className="price">$2500</span>/month</p>
                                </Card.Text>
                                <Button
                                  id="choose-pro"
                                  onClick={e => {
                                    e.stopPropagation();

                                    // if (! trialForm)
                                    // {
                                      if (! all)
                                      {
                                        setRaces([]);
                                      }
                                      setAll(! all);
                                    //}
                                  }}
                                >
                                  {(trialForm ? 'FREE 30-Day trial' : 'Choose Pro')}
                                </Button>
                              </Card.Body>
                            </Card>

                          </Col>
                        ) : null}

                      </Row>

                      <Modal show={chooseRaces} onHide={handleClose}>
                        <Modal.Header closeButton />
                        <Modal.Body>
                          <ChooseRaces
                            name="races"
                            selected={preRaces}
                            choices={availableRaces.map(race => (
                              {
                                value: race.name,
                                label: formatRace(race.name)
                              }
                            ))}
                            onChange={(name) => setPreRaces(toggleMultiple(
                              name,
                              preRaces
                            ))}
                            clear={(e) => {
                              e.preventDefault();
                              setPreRaces([]);
                            }}
                          />
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            onClick={() => {
                              setRaces([...preRaces]);
                              handleClose();
                            }}
                          >
                            Continue
                          </Button>
                        </Modal.Footer>
                      </Modal>

                    </Col>
                    {all || races.length > 0 ? (
                      <Col>
                        <Card className="p-4">
                          <table className="table table-borderless my-2">
                            <tbody>
                              <tr>
                                <th scope="row">Plan</th>
                                <td className="text-right">{all ? 'Pro' : 'Pay Per Race'}</td>
                              </tr>
                              {races.length > 0 ? (
                                <tr>
                                  <th scope="row">Races</th>
                                  <td className="text-right">{races.map(race => formatRace(race)).join(', ')}</td>
                                </tr>
                              ) : null}
                              {trialForm ? null : (
                                <tr>
                                  <th scope="row">Total</th>
                                  <td className="text-right">{calculateTotal()}/month</td>
                                </tr>
                              )}
                              <tr>
                                <th scope="row">Billed Today</th>
                                <td className="text-right">
                                  {trialForm ? '$0 (Free Trial)' : calculateTotal()}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {trialForm ? (
                            <p>* Access to all data is free for 30 days with the option to subscribe to individual races after the trial expires.</p>
                          ) : null}
                          <form onSubmit={handleSubmit}>
                            {!loggedIn ? (
                              <>
                                <h3 className="text-muted">Create your account</h3>
                                <Form.Control
                                  id="name"
                                  placeholder="Name"
                                  value={name}
                                  onChange={e => setName(e.target.value)}
                                  isInvalid={errors.name}
                                />
                                {errors.name ? (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.name[0]}
                                  </Form.Control.Feedback>
                                ) : null}
                                <Form.Control
                                  id="email"
                                  className="mt-2"
                                  placeholder="Email"
                                  value={email}
                                  onChange={e => setEmail(e.target.value)}
                                  isInvalid={errors.email}
                                />
                                {errors.email ? (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.email[0]}
                                  </Form.Control.Feedback>
                                ) : null}
                                <Form.Control
                                  id="password"
                                  className="mt-2"
                                  type="password"
                                  placeholder="Password"
                                  value={password}
                                  onChange={e => setPassword(e.target.value)}
                                  isInvalid={errors.password}
                                />
                                {errors.password ? (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.password[0]}
                                  </Form.Control.Feedback>
                                ) : null}
                                <Form.Control
                                  id="confirm-password"
                                  className="mt-2"
                                  type="password"
                                  placeholder="Confirm Password"
                                  value={passwordConfirmation}
                                  onChange={e => setPasswordConfirmation(e.target.value)}
                                  isInvalid={errors.password_confirmation}
                                />
                                {errors.password_confirmation ? (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.password_confirmation[0]}
                                  </Form.Control.Feedback>
                                ) : null}
                              </>
                            ) : null}
                            <>
                              <h3 className="text-muted">Billing Information</h3>
                              <CardElement className="form-control mt-2" />
                            </>
                            <button className="btn btn-primary mt-4" disabled={!stripe}>{trialForm ? 'Get Started' : 'Check Out'}
                              {submitting ? (
                                <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
                              ) : (
                                <ArrowRight style={{fontSize: 20}} />
                              )}
                            </button>
                            {error ? (
                              <Alert className="mt-2" variant="danger" onClose={() => setError('')} dismissible>
                                <Alert.Heading>Error</Alert.Heading>
                                {error}
                              </Alert>
                            ) : null}
                              <Modal
                                show={success}
                                onHide={() => setSuccess(false)}
                              >
                                <Modal.Header closeButton>
                                  <Modal.Title>
                                    Success!
                                  </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                {all ? (
                                  <p>
                                    {trialForm ? (
                                      'Welcome to 527 Tracker. Enjoy your 30 day trial.'
                                    ): (
                                      'Welcome to 527 Tracker. You now have access to all expenditure data.'
                                    )}
                                  </p>
                                ) : (
                                  <p>
                                    Welcome to 527 Tracker. You now have access to data for the following races: {races.map(race => formatRace(race)).join(', ')}
                                  </p>
                                )}
                                  <a
                                    id="go-to-data"
                                    href="/home"
                                    className="btn btn-primary mb-3"
                                  >
                                    Go to Data
                                  </a>
                                </Modal.Body>
                              </Modal>
                          </form>
                        </Card>
                      </Col>
                    ) : null}
                  </Row>
                </div>
            </div>
        </div>
      </>
  )
};

const SubscriptionForm = () => {

  const setupIntent = document.getElementById('setup_intent').value;

  const options = {
    // passing the client secret obtained from the server
    clientSecret: setupIntent,
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      <CheckoutForm />
    </Elements>
  );
};

if (document.getElementById('subscription-form')) {
  const root = createRoot(document.getElementById('subscription-form')); // createRoot(container!) if you use TypeScript
  root.render(<SubscriptionForm />);
}
